export default {
    'country.CN': '中国',
    'country.US': '美国',
    'country.JP': '日本',
    'country.GB': '英国',
    'country.DE': '德国',
    'country.FR': '法国',
    'country.IN': '印度',
    'country.BR': '巴西',
    'country.RU': '俄罗斯',
    'country.KR': '韩国',

    'country.select.placeholder': '请选择国家',
    'country.phone.code': '区号: '
}